import React from 'react'

export default () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/action/visibility_off_24px">
      <path
        id="icon/action/visibility_off_24px_2"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5175 4.89385L1.5075 2.88385L2.565 1.81885L15.8625 15.1238L14.805 16.1813L12.24 13.6163C11.235 14.0138 10.14 14.2313 9 14.2313C5.25 14.2313 2.0475 11.8988 0.75 8.60635C1.3275 7.12885 2.295 5.85385 3.5175 4.89385ZM8.99991 4.4814C11.8424 4.4814 14.3774 6.0789 15.6149 8.6064C15.1724 9.5214 14.5499 10.3089 13.8074 10.9464L14.8649 12.0039C15.9074 11.0814 16.7324 9.9264 17.2499 8.6064C15.9524 5.3139 12.7499 2.9814 8.99991 2.9814C8.04741 2.9814 7.13241 3.1314 6.26991 3.4089L7.50741 4.6464C7.99491 4.5489 8.48991 4.4814 8.99991 4.4814ZM8.19758 5.3364L9.75008 6.8889C10.1776 7.0764 10.5226 7.4214 10.7101 7.8489L12.2626 9.4014C12.3226 9.1464 12.3676 8.8764 12.3676 8.5989C12.3751 6.7389 10.8601 5.2314 9.00008 5.2314C8.72258 5.2314 8.46008 5.2689 8.19758 5.3364ZM7.1325 8.50887L9.09 10.4664L9.08999 10.4664C9.05999 10.4739 9.03 10.4814 9 10.4814C7.965 10.4814 7.125 9.64137 7.125 8.60637C7.125 8.58762 7.12687 8.57262 7.12875 8.55762L7.12875 8.55761C7.13063 8.54261 7.1325 8.52761 7.1325 8.50887ZM5.89508 7.27134L4.58258 5.95884C3.67508 6.64884 2.91008 7.53384 2.38508 8.60634C3.62258 11.1338 6.15758 12.7313 9.00008 12.7313C9.71258 12.7313 10.4026 12.6263 11.0626 12.4463L10.3276 11.7113C9.92258 11.8838 9.47258 11.9813 9.00008 11.9813C7.14008 11.9813 5.62508 10.4663 5.62508 8.60634C5.62508 8.13384 5.72258 7.68384 5.89508 7.27134Z"
        fill="#C4C4C4"
      />
    </g>
  </svg>
)
